(function () {
  var root = document.querySelector("[data-partner-dash]");
  if (!root) return;

  var TOKEN_KEY = "sora_partner_token";
  var gate = root.querySelector("[data-dash-gate]");
  var app = root.querySelector("[data-dash-app]");
  var loginForm = root.querySelector("[data-dash-login]");
  var loginStatus = root.querySelector("[data-dash-login-status]");
  var lbPeriod = "24h";
  var lbCache = null;

  function apiBase() {
    return (root.getAttribute("data-api-base") || "").replace(/\/$/, "") ||
      "https://sora-climate-bridge.onrender.com";
  }

  function getToken() {
    try {
      var q = new URLSearchParams(window.location.search).get("token");
      if (q) {
        localStorage.setItem(TOKEN_KEY, q);
        return q;
      }
      return localStorage.getItem(TOKEN_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function clearToken() {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch (e) {}
  }

  function setLoginStatus(msg, isError) {
    if (!loginStatus) return;
    loginStatus.textContent = msg || "";
    loginStatus.classList.toggle("is-error", Boolean(isError));
  }

  function moneyUsd(n) {
    var v = Number(n || 0);
    return "$" + v.toFixed(2);
  }

  async function api(path, opts) {
    opts = opts || {};
    var headers = Object.assign(
      { Accept: "application/json" },
      opts.headers || {}
    );
    var token = getToken();
    if (token) headers.Authorization = "Bearer " + token;
    if (opts.body && !headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }
    var res = await fetch(apiBase() + path, {
      method: opts.method || "GET",
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    });
    var data = await res.json().catch(function () {
      return {};
    });
    return { ok: res.ok, status: res.status, data: data };
  }

  function showApp(on) {
    if (gate) gate.hidden = on;
    if (app) app.hidden = !on;
  }

  function renderProfile(partner) {
    var el = root.querySelector("[data-dash-profile]");
    if (!el || !partner) return;
    el.innerHTML =
      "<p><strong>" +
      escapeHtml(partner.friendlyName || partner.fullName || "Partner") +
      "</strong> · <code>" +
      escapeHtml(partner.affTag || "") +
      "</code> · " +
      escapeHtml(partner.status || "") +
      "</p>" +
      (partner.trackingUrl
        ? "<p>Tracking: <a href=\"" +
          escapeAttr(partner.trackingUrl) +
          "\">" +
          escapeHtml(partner.trackingUrl) +
          "</a></p>"
        : "") +
      (partner.discountCode
        ? "<p>Code: <strong>" + escapeHtml(partner.discountCode) + "</strong></p>"
        : "<p>Shareable code issued after seat approval.</p>");
  }

  function renderStats(earnings, partner) {
    var pending = root.querySelector("[data-stat-pending]");
    var available = root.querySelector("[data-stat-available]");
    var paid = root.querySelector("[data-stat-paid]");
    var pendingNote = root.querySelector("[data-stat-pending-note]");
    var gbp = root.querySelector("[data-stat-gbp]");
    var amb = root.querySelector("[data-stat-ambassadors]");
    var orders = root.querySelector("[data-stat-orders]");
    var pause = root.querySelector("[data-dash-payout-pause]");
    var pauseMsg = root.querySelector("[data-dash-payout-pause-msg]");
    var holdNote = root.querySelector("[data-dash-hold-note]");

    if (pending) pending.textContent = moneyUsd(earnings.pendingUsd);
    if (available) available.textContent = moneyUsd(earnings.availableUsd);
    if (paid) paid.textContent = moneyUsd(earnings.paidUsd);
    if (pendingNote) {
      var hold = earnings.holdDays || partner.holdDays || 14;
      var clearsIn =
        earnings.clearsIn != null
          ? earnings.clearsIn
          : earnings.holdDaysRemaining != null
            ? earnings.holdDaysRemaining
            : earnings.pendingHold && earnings.pendingHold.clearsIn != null
              ? earnings.pendingHold.clearsIn
              : null;
      if (Number(earnings.pendingUsd || 0) > 0 && clearsIn != null) {
        pendingNote.textContent =
          clearsIn <= 0
            ? "Clearing soon · then Available"
            : "Pending (clears in " +
              clearsIn +
              " day" +
              (clearsIn === 1 ? "" : "s") +
              ")";
      } else {
        pendingNote.textContent = "Clears after " + hold + "-day hold";
      }
    }
    if (gbp) {
      gbp.textContent =
        "£" +
        Number(earnings.paidGbp || 0).toFixed(2) +
        " paid · FX " +
        (earnings.fxGbpUsd || "n/a");
    }
    if (amb) {
      amb.textContent = String(
        earnings.ambassadorsReferredCount != null
          ? earnings.ambassadorsReferredCount
          : partner.ambassadorsReferredCount || 0
      );
    }
    if (orders) orders.textContent = String(earnings.referralCount || 0);

    var paused = Boolean(
      earnings.payoutsPaused || partner.payoutsPaused
    );
    if (pause) {
      pause.hidden = !paused;
      if (pauseMsg) {
        pauseMsg.textContent =
          earnings.payoutPauseMessage ||
          partner.payoutPauseMessage ||
          "Future payouts are blocked until ops clears the balance.";
      }
    }
    if (holdNote && earnings.note) {
      holdNote.textContent = earnings.note;
    }
  }

  function renderAmbassadors(items) {
    var list = root.querySelector("[data-ambassadors-list]");
    var empty = root.querySelector("[data-ambassadors-empty]");
    if (!list) return;
    list.innerHTML = "";
    var rows = items || [];
    if (!rows.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    rows.forEach(function (r) {
      var li = document.createElement("li");
      li.textContent =
        (r.handle || r.firstName || "Partner") +
        (r.status ? " · " + r.status : "");
      list.appendChild(li);
    });
  }

  function renderLeaderboard(bundle) {
    lbCache = bundle;
    var periodKey = lbPeriod === "24h" ? "last24h" : "allTime";
    var lb = (bundle && bundle[periodKey]) || (bundle && bundle.leaderboard) || {};
    var body = root.querySelector("[data-lb-body]");
    var fx = root.querySelector("[data-lb-fx]");
    var note = root.querySelector("[data-lb-note]");
    if (fx) {
      fx.textContent =
        (lb.periodLabel || (lbPeriod === "24h" ? "Last 24 hours" : "All time")) +
        " · ranked by USD gained · FX GBP→USD " +
        (bundle.fxGbpUsd || lb.fxGbpUsd || "n/a");
    }
    if (note) note.textContent = lb.note || "";
    if (!body) return;
    body.innerHTML = "";
    (lb.top || []).forEach(function (row) {
      var tr = document.createElement("tr");
      if (row.isYou) tr.className = "is-you";
      tr.innerHTML =
        "<td>" +
        row.rank +
        "</td><td>" +
        escapeHtml(row.handle) +
        (row.isYou ? " <em>you</em>" : "") +
        "</td><td>" +
        moneyUsd(row.usdGained) +
        "</td><td>" +
        (row.ambassadorsReferredCount || 0) +
        "</td><td>" +
        (row.referralOrderCount || 0) +
        "</td>";
      body.appendChild(tr);
    });
    if (!(lb.top || []).length) {
      var tr0 = document.createElement("tr");
      tr0.innerHTML =
        '<td colspan="5">No leaderboard rows yet. Honest zeros until referred sales clear.</td>';
      body.appendChild(tr0);
    }
  }

  function renderReferrals(ref) {
    var list = root.querySelector("[data-referrals-list]");
    var empty = root.querySelector("[data-referrals-empty]");
    if (!list) return;
    list.innerHTML = "";
    var items = (ref && ref.items) || [];
    if (!items.length) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = (ref && ref.emptyNote) || "No attributed referrals yet.";
      }
      return;
    }
    if (empty) empty.hidden = true;
    items.forEach(function (item) {
      var li = document.createElement("li");
      var status =
        item.statusLabel ||
        item.commissionStatus ||
        (item.tracking && (item.tracking.status || item.tracking.statusKey)) ||
        "Pending";
      li.innerHTML =
        "<strong>" +
        escapeHtml(item.shopifyOrderName || "Order") +
        "</strong> · " +
        moneyUsd(item.estimateCommissionUsd) +
        " · " +
        escapeHtml(String(status)) +
        (item.tracking
          ? " · " + escapeHtml(item.tracking.carrierMasked || "SORA Delivery")
          : "");
      list.appendChild(li);
    });
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, "&#39;");
  }

  async function loadDashboard() {
    var token = getToken();
    if (!token) {
      showApp(false);
      return;
    }

    // Confirm token
    var login = await api("/api/partner/session/login", {
      method: "POST",
      body: { token: token },
    });
    if (!login.ok) {
      clearToken();
      showApp(false);
      setLoginStatus("Session expired. Request a new dashboard link.", true);
      return;
    }

    showApp(true);
    var me = await api("/api/partner/me");
    var earn = await api("/api/partner/earnings");
    var lb = await api("/api/partner/leaderboard");
    var refs = await api("/api/partner/referrals");

    if (!me.ok) {
      clearToken();
      showApp(false);
      setLoginStatus(me.data.error || "Could not load partner profile.", true);
      return;
    }

    renderProfile(me.data.partner);
    if (earn.ok) {
      renderStats(earn.data.earnings, me.data.partner);
      renderAmbassadors(
        earn.data.earnings.ambassadorsReferred ||
          me.data.partner.ambassadorsReferred ||
          []
      );
    } else {
      renderStats(
        {
          combinedEstimateUsd: me.data.partner.earningsUsdAllTime || 0,
          combinedEstimateGbp: me.data.partner.earningsGbpAllTime || 0,
          last24hUsd: 0,
          ambassadorsReferredCount: me.data.partner.ambassadorsReferredCount || 0,
          referralCount: 0,
          fxGbpUsd: me.data.partner.fxGbpUsd,
        },
        me.data.partner
      );
      renderAmbassadors(me.data.partner.ambassadorsReferred || []);
    }
    if (lb.ok) renderLeaderboard(lb.data);
    if (refs.ok) renderReferrals(refs.data.referrals);

    // Strip token from URL after store
    if (window.history && window.location.search.indexOf("token=") >= 0) {
      window.history.replaceState({}, "", window.location.pathname);
    }
  }

  if (loginForm) {
    loginForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      var email = String(new FormData(loginForm).get("email") || "").trim();
      if (!email || email.indexOf("@") < 0) {
        setLoginStatus("Enter a valid email.", true);
        return;
      }
      setLoginStatus("Sending link…", false);
      var res = await api("/api/partner/session/request-link", {
        method: "POST",
        body: { email: email },
      });
      var mailFailed =
        Boolean(res.data && res.data.mailFailed) ||
        (res.data && res.data.code === "partner_magic_link_send_failed");
      var msg =
        (res.data && (res.data.message || res.data.error)) ||
        (res.ok
          ? "If we have an application for this email, a link is on its way."
          : "Could not send the dashboard link. Try again or email hello@soraclimate.com.");
      setLoginStatus(msg, !res.ok || mailFailed);
    });
  }

  root.querySelectorAll("[data-lb-period]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      lbPeriod = btn.getAttribute("data-lb-period") || "24h";
      root.querySelectorAll("[data-lb-period]").forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (lbCache) renderLeaderboard(lbCache);
    });
  });

  var logout = root.querySelector("[data-dash-logout]");
  if (logout) {
    logout.addEventListener("click", function () {
      clearToken();
      showApp(false);
      setLoginStatus("Signed out of Partner Dashboard.", false);
    });
  }

  loadDashboard();
})();
